// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/app/splash-page/main.scss
// module id = 174
// module chunks = 7